/** Экран «не открылось» с фактами вместо догадок.
 *
 * «Ошибка сети» не помогает никому. Полезно другое: дошёл ли запрос до
 * сервера, пришла ли подпись от Telegram, какой клиент и какой адрес — по этим
 * строкам причина находится сразу, а человеку сверху пишется одна фраза о том,
 * что делать. Витрина и админка ломаются одинаково, различаются только словами
 * про то, откуда их открывают, — поэтому экран один.
 */
import { useEffect, useState } from 'react';
import type { ApiError } from './api';
import { initData, tg } from './tg';
import { Note } from './ui';

interface Props {
  error: ApiError;
  surface: 'shop' | 'admin';
}

export function FailScreen({ error, surface }: Props) {
  const [reachable, setReachable] = useState<boolean | null>(null);

  useEffect(() => {
    fetch('/api/ping', { cache: 'no-store' })
      .then((response) => setReachable(response.ok))
      .catch(() => setReachable(false));
  }, []);

  const app = tg();
  const signature = initData().length;
  const admin = surface === 'admin';

  // Порядок важен: каждая следующая догадка имеет смысл, только если
  // предыдущая отпала. Так человек получает одну причину, а не список.
  let hint: string;
  if (!app) {
    hint = admin
      ? 'Страница открыта вне Telegram. Админку открывают кнопкой из /admin.'
      : 'Страница открыта вне Telegram. Витрину открывают кнопкой в боте.';
  } else if (reachable === false) {
    hint = 'Сервер бота не отвечает: проверьте, что он запущен и туннель жив.';
  } else if (signature === 0) {
    hint = admin
      ? 'Telegram не передал подпись. Откройте /admin в боте заново — кнопка из старого сообщения помнит прежний адрес.'
      : 'Telegram не передал подпись. Нажмите в боте /start и откройте витрину заново — кнопка из старого сообщения помнит прежний адрес.';
  } else if (admin && error.status === 403) {
    hint = 'Подпись принята, но вашего ID нет в admin_ids.';
  } else if (error.status === 401) {
    hint =
      'Сервер не принял подпись. Обычно это другой токен бота или просроченная сессия — ' +
      (admin ? 'откройте админку заново.' : 'переоткройте витрину.');
  } else {
    hint = 'Неожиданная ошибка, подробности ниже.';
  }

  return (
    <div className="pt-6">
      <Note tone="warn">{hint}</Note>
      <div className="glass mt-3 rounded-card p-4 font-mono text-xs leading-relaxed whitespace-pre-wrap text-hint">
        {[
          `клиент: ${app?.platform ?? '—'} ${app?.version ?? ''}`.trim(),
          `подпись Telegram: ${signature ? `${signature} симв.` : 'НЕТ'}`,
          `сервер: ${reachable === null ? 'проверяю…' : reachable ? 'отвечает' : 'НЕ отвечает'}`,
          `адрес: ${location.origin}`,
          `ошибка: ${error.message}`,
        ].join('\n')}
      </div>
    </div>
  );
}
